import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'mobile-balances-dialog',
    templateUrl: 'balances-dialog.component.html'
})
export class BalancesMobileDialog {

    constructor(
        public dialogRef: MatDialogRef<BalancesMobileDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

}
